export type ScenarioWorkspaceScope = "partner";

const scopedWorkspaceIds = new Map<ScenarioWorkspaceScope, string>();

export function registerScenarioWorkspaceScope(scope: ScenarioWorkspaceScope, workspaceId: string): void {
    scopedWorkspaceIds.set(scope, workspaceId);
}

export function getScenarioWorkspaceScope(scope: ScenarioWorkspaceScope): string | undefined {
    return scopedWorkspaceIds.get(scope);
}
